import { render } from "./PracticeTemplateEditorNew.vue?vue&type=template&id=c03944ec&ts=true"
import script from "./PracticeTemplateEditorNew.vue?vue&type=script&lang=ts"
export * from "./PracticeTemplateEditorNew.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__